module.exports = __webpack_public_path__ + "img/portfolio9.c4d07a72.jpg";